import React, { } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancelForm } from '../../clients/hooks/useCancelForm';
import { RootStateOrAny, useSelector } from 'react-redux';
import { wrapper } from '../../reports/styles/style';
import OrderDetailTxt from '../../orders/components/forms/edditOrder/OrderDetailTxt';
import { useReceptionPlacesShowForm } from '../hooks/useReceptionPlacesShowForm';
import { translateOrderTypeName } from '../../common/enums/orderTypes.enum';

const ReceptionPlacesShowForm = () => {
    const { t } = useTranslation("admin");
    const { initValues } = useReceptionPlacesShowForm()

    return (
        <div className={wrapper}>
            <div>
                <OrderDetailTxt
                    title={t("nav.address") as string}
                    value={initValues.receptionPlaceAddress}
                />
                    <OrderDetailTxt
                        title={t("nav.bdoNumber") as string}
                        value={initValues.bdoNumber}
                    />
                    <OrderDetailTxt
                        title={t("clients.columns.orderTypes") as string}
                        value={translateOrderTypeName(initValues.orderType, t)}
                    />
                    <OrderDetailTxt
                        title={t("receptionPlaces.columns.phone") as string}
                        value={initValues.phone}
                    />
                    <OrderDetailTxt
                        title={t("nav.companyName") as string}
                        value={initValues.companyName}
                    />
                    <OrderDetailTxt
                        title={t("nav.containersQuantity") as string}
                        value={initValues.containersAmount}
                    />
            </div>
        </div>
    )
};

export default ReceptionPlacesShowForm;